import * as Yup from "yup";
import messages from "../../../assets/locale/messages";

export const ADD_EDIT_CATEGORY_SCHEMA = (lang, isSubTopic) => {
  const {
    flashcard: {
      topic: {
        validation: { topicNameRequired, systemCodeRequired }
      },
      subTopic: {
        validation: { subTopicNameRequired, subjectCodeRequired }
      }
    }
  } = messages[lang];

  return isSubTopic
    ? Yup.object().shape({
        name: Yup.string().required(subTopicNameRequired),
        subject_code: Yup.string().required(subjectCodeRequired)
      })
    : Yup.object().shape({
        name: Yup.string().required(topicNameRequired),
        system_code: Yup.string().required(systemCodeRequired)
      });
};

export const getInitialValues = (flashcard_topics) => {
  return flashcard_topics?.isSubTopic
    ? {
        name: flashcard_topics?.selectedTopicOrSubTopic?.name || "",
        subject_code:
          flashcard_topics?.selectedTopicOrSubTopic?.subject_code ||
          ""
      }
    : {
        name: flashcard_topics?.selectedTopicOrSubTopic?.name || "",
        system_code:
          flashcard_topics?.selectedTopicOrSubTopic?.system_code || ""
      };
};
